import { type ReactElement } from 'react';
import { type CardProps } from '@ironhack/design-system2/components/card';
import { GridCard as DsGridCard } from '@ironhack/design-system2/components/grid-card';

import { CmsImage } from '@/app/components/server/cms-image';
import { type DatoGridCardBlock } from '@/lib/datocms';
import { Link } from '@/app/components/client/link';

type Props = {
  card: DatoGridCardBlock;
  orientation?: 'horizontal' | 'vertical';
  size?: 's';
} & Omit<CardProps, 'size'>;

export const GridCard = (props: Props): ReactElement => {
  const {
    card: {
      image,
      tag: [tag],
      target: [target],
      ...cardData
    },
    ...cardProps
  } = props;

  return (
    <Link withoutDecoration {...target}>
      <DsGridCard
        tag={tag}
        {...(image && {
          image: <CmsImage data={image.responsiveImage} sizes="156px" />,
        })}
        {...cardData}
        {...cardProps}
      />
    </Link>
  );
};
